declare global {
  interface Window {
    CookieYes?: {
      getConsent: () => { [key: string]: boolean };
    };
  }
}

const loadGoogleAnalytics = (key: string) => {
  const script1 = document.createElement("script");
  script1.async = true;
  script1.src = "https://www.googletagmanager.com/gtag/js?id=" + key;
  document.head.appendChild(script1);

  const script2 = document.createElement("script");
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${key}');
  `;
  document.head.appendChild(script2);
};

const googleAnalyticsAllowed = () => {
  if (window.CookieYes && window.CookieYes.getConsent) {
    const consent = window.CookieYes.getConsent();
    if (consent && consent["analytics"]) {
      return true;
    } else {
      return false;
    }
  }
  return undefined;
};

export const Scripts = {
  loadGoogleAnalytics,
  googleAnalyticsAllowed,
};
